var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ca87bb819c60dc8bf019d2b55e348fc193831f86"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["reku-web@reku"]={id:"ca87bb819c60dc8bf019d2b55e348fc193831f86"};
      